import React from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Page from '../../../shared/components/layout/Page.layout';
import BuscadorPacientes from '../../../pacientes/components/BuscadorPacientes';
import { establecerCliente } from '../../../../state/actions/creators/encargos.creador.actioncreator';
import Text from '../../../shared/components/basic/Text';


class EncargosCrearSeleccionarPacientePage extends React.Component {
  render() {
    return (
      <Page
        titulo="Búsqueda de clientes"
        navigationItems={[
          {
            node: <Text translationId="navegacion.home" />,
            link: '',
          },
          {
            node: <Text translationId="navegacion.encargos" />,
          },
        ]}
      >
        <BuscadorPacientes onSeleccionarPaciente={datos => this.onSeleccionarPaciente(datos)} />
      </Page>
    );
  }

  onSeleccionarPaciente(datos) {
    const { establecerCliente, history } = this.props;

    if (datos) {
      const { record } = datos;
      if (record) {
        const cliente = {
          id: record.id,
          nombreCompleto: record.nombre_completo,
          tiendaId: record.tienda_id,
          fechaUltimaGraduacionOptometrica: record.fecha_ultima_gradopt,
          fechaUltimaGraduacionContactologica: record.fecha_ultima_gradcontac,
          codigoGrupoCliente: record.cod_grupo_cliente,
        };
        establecerCliente({ encargoUUID: this.props.match.params.encargoUUID, cliente });
        history.goBack();
      }
    }
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    establecerCliente,
  }, dispatch);
}
export default connect(
  null,
  mapDispatchToProps,
)(EncargosCrearSeleccionarPacientePage);

EncargosCrearSeleccionarPacientePage.propTypes = {
  tiendas: PropTypes.any,
};

EncargosCrearSeleccionarPacientePage.defaultProps = {
  tiendas: [],
};
